<template>
  <div class="t-list-container">
    <div
      v-if="loading"
      class="no-data-container"
    >
      <img
        src="@shared/assets/img/general/loading-white.svg"
        alt="Loading"
      >
    </div>
    <div
      v-else-if="technicians.length === 0"
      class="empty-container"
    >
      <div class="t-header">
        Start Installing Today!
      </div>
      <div class="flex-row align-center">
        <img
          src="@shared/assets/img/general/pro-app-logo.svg"
          alt="pro-app-logo"
          class="pro-app-logo"
        >
        <div class="t-body">
          Invite your technicians to the SmartAC.com
          <br>
          PRO App to see more details
        </div>
      </div>
      <div class="t-image-container">
        <img
          class="truck-img"
          src="@shared/assets/img/technician/truck.png"
          alt="Technician Work Truck"
        >
      </div>
      <div class="t-button-container">
        <button
          type="button"
          class="t-button"
          @click="toggleActionModal(true, 'invite-tech')"
        >
          Invite a tech
        </button>
        <button
          type="button"
          class="t-button"
          @click="toggleActionModal(true, 'bulk-tech', {})"
        >
          Import from .CSV
        </button>
      </div>
    </div>
    <TechnicianItem
      v-for="technician in tableData"
      v-else
      :key="technician.id"
      :technician="technician"
      :resendInvite="resendInvite"
    />
  </div>
</template>

<script>
import technicianMixin from '@shared/mixins/technicianMixin';
import TechnicianItem from './TechnicianItem.vue';

export default {
  name: 'TechnicianList',
  components: {
    TechnicianItem,
  },
  mixins: [technicianMixin],
  props: {
    loading: Boolean,
    search: String,
    resendInvite: Function,
  },
  computed: {
    tableData() {
      if (this.search) {
        const searchTerm = this.search?.toLowerCase();
        return this.technicians.filter((technician) => {
          const firstName = technician?.firstName;
          const lastName = technician?.lastName;
          const name = `${firstName} ${lastName}`.trim();
          const email = technician?.email;
          const phone = technician?.phone;
          const company = technician?.company;
          return (
            (name && name.toLowerCase().includes(searchTerm))
            || (email && email.toLowerCase().includes(searchTerm))
            || (phone && phone.replaceAll('-', '').toLowerCase().includes(searchTerm))
            || (company && company.toLowerCase().includes(searchTerm))
          );
        });
      }
      return this.technicians;
    },
  },
};
</script>

<style lang="scss">

.t-list-container {
  margin-top: 50px;
}

.empty-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $WHITE;

  .t-header {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .t-body {
    font-weight: 500;
    font-size: 1rem;
    margin-left: 16px;
  }

  .t-image-container {
    margin-top: 42px;
    margin-bottom: 28px;
    position: relative;

    .truck-img {
      width: 490px;
    }
  }

  .t-button-container {
    .t-button {
      padding: 16px 24px;
      font-weight: 700;
      border-radius: 8px;

      &:first-child {
        margin-right: 24px;
        background-color: $N50;
      }

      &:last-child {
        background-color: $NBLUE100;
      }
    }
  }
}
</style>
